import React, { useState, useEffect } from "react";
import Input from "../../../ui/Input/Input";
import "./Multi.css";

function Multi({ question, onUpdateAnswer, invalidKeys }) {
  const [selectedAnswer, setSelectedAnswer] = useState([]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [otherText, setOtherText] = useState("");
  const [multiAnswer, setMultiAnswer] = useState([]);
  const isInvalid = invalidKeys.includes(question.key);

  useEffect(() => {
    let multiAnswersCopy = [...multiAnswer];
    multiAnswersCopy[question.answers.length] = otherText;
    const answer = {
      key: question.key,
      answer: multiAnswersCopy,
      question: question.description,
      type: question.answersType,
    };
    onUpdateAnswer(answer);
  }, [multiAnswer, otherText]);

  function onSelectAnswear(item) {
    const key = item.key;
    if (selectedAnswer.includes(key)) {
      const filtered = selectedAnswer.filter((sa) => sa !== key);
      setSelectedAnswer(filtered);
      const multiFiltered = multiAnswer.filter((ma) => ma !== item.title);
      setMultiAnswer(multiFiltered);
    } else {
      if (key === 0) {
        setSelectedAnswer([0]);
        setMultiAnswer(["Ninguna"]);
        setIsOtherSelected(false);
        setOtherText("");
      } else {
        const filtered = selectedAnswer.filter((sa) => sa !== 0);
        setSelectedAnswer(filtered);
        const multiFiltered = multiAnswer.filter((ma) => ma !== "Ninguna");
        setMultiAnswer(multiFiltered);
        setSelectedAnswer((oldArray) => [...oldArray, key]);
        setMultiAnswer((oldArray) => [...oldArray, item.title]);
      }
    }
  }

  function onSelectOther() {
    const key = question.answers.length;
    if (selectedAnswer.includes(key)) {
      setIsOtherSelected(false);
      setOtherText("");
      const filtered = selectedAnswer.filter((sa) => sa !== key);
      setSelectedAnswer(filtered);
    } else {
      const filtered = selectedAnswer.filter((sa) => sa !== 0);
      setSelectedAnswer(filtered);
      const multiFiltered = multiAnswer.filter((ma) => ma !== "Ninguna");
      setMultiAnswer(multiFiltered);
      setSelectedAnswer((oldArray) => [...oldArray, key]);
      setIsOtherSelected(true);
    }
  }

  function updateOtherTextHandler(e) {
    const enteredValue = e.target.value;
    setOtherText(enteredValue);
  }

  function LoadSingleAnswer() {
    return question.answers.map((item) => {
      const isSelected = selectedAnswer.includes(item.key);
      return (
        <div
          key={item.key}
          className={isSelected ? "multiButton" : "multiButtonSelected"}
          onClick={onSelectAnswear.bind(this, item)}
        >
          <div>
            <p className="multiButtonText">{item.title}</p>
          </div>
        </div>
      );
    });
  }

  return (
    <div className={isInvalid ? "error" : "mainMulti"}>
      <p className="multiQuestion">{question.description}</p>
      <LoadSingleAnswer />
      {question.canBeOpen && (
        <div>
          <div
            className={
              selectedAnswer === question.answers.length
                ? "multiButton"
                : "multiButtonSelected"
            }
            onClick={onSelectOther}
          >
            <div>
              <p className="multiButtonText">Otro</p>
            </div>
          </div>
          {isOtherSelected && (
            <div>
              <Input
                label="Especifique:"
                onUpdateValue={updateOtherTextHandler}
                value={otherText}
                autoCompleteType="off"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Multi;
